// Brand logo helpers — served from /public
// mindscope-logo.png            : full logo w/ original navy background
// mindscope-logo-transparent.png: full logo (mark + wordmark) with transparent background
// mindscope-mark.png            : diamond mark only, transparent background

export function BrandLogo({ variant = "full", className = "", alt = "Mindscope" }) {
  const src =
    variant === "mark"
      ? "/mindscope-mark.png"
      : variant === "boxed"
      ? "/mindscope-logo.png"
      : "/mindscope-logo-transparent.png";
  return <img src={src} alt={alt} className={className} draggable={false} />;
}

export default BrandLogo;
